<script>
import Layout from "../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { filter } from "../../helpers/Vue-Filter";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/ja";
import "vue2-datepicker/locale/en";
import {hospitalMethods, hospitalComputed, configMethods, configComputed} from "@/state/helpers";
import Loader from "../../components/widgets/loader.vue";
import Add from "./add.vue";
import RokomoTest from "./rokomo-test.vue";
import { mixin } from "../../helpers/Vue-Mixin";
import api from "@/api/";
import {getProfile} from "../../helpers/Auth";
import moment from 'moment';
import EditProfileUser from "@/components/widgets/edit-profile-user.vue";
import Pagination from "../../components/widgets/pagination.vue";

export default {
  /* eslint-disable no-console */
  filters: {
    ...filter,
  },

  mixins: [mixin],

  page: {
    title: "患者一覧",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: { Layout, PageHeader, DatePicker, Multiselect, Loader, Add, RokomoTest, EditProfileUser, Pagination },

  data() {
    return {
      items: [
        {
          text: "患者一覧",
          href: "/hospital/patients",
          active: true,
        },
      ],

      filter: {},
      pagination: {
        current_page: 1,
        total: 20,
        per_page: 20,
      },
      loader: false,
      valueSelectSex: null,
      page: 1,
      paginationPages: 5,
      sortBy: "age",
      sortDesc: false,
      excelIds: [],
      keySort: "created_at",
      typeSort: 0,
      types: ["desc", "asc"],

      isAll: false,
      ignoreIds: [],
      role: 'user',
      openedAddModal: false,
      openedTestModal: false,
      profile: getProfile(),
      testingUser: {},
      lastLoadedTime: null,
      isFilterOpen: false,
      showModalEditProfileUser: false,
      dataEdit:[]
    };
  },

  created() {
    try {
      this.loader = true;
      this.getHCountUser();
      this.getConfig();
      this.fetchHospital(
        Object.assign(
          {},
          {
            role: this.role,
            page: 1,
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
          }
        )
      ).then((e) => {
        if (e.status === 200) {
          this.loader = false;
        }
      });
      this.pagination = Object.assign(this.gPaginationHospital, {});
    } catch (error) {
      console.log(error);
    }
    const formattedDate = moment().format('YYYY/MM/DD HH:mm:ss');
    localStorage.setItem('lastLoadedTime', formattedDate);
    this.lastLoadedTime = localStorage.getItem('lastLoadedTime');
    this.$store.dispatch('saveTheme', this.profile.role?.name === 'admin' ? 'admin' : this.profile.facility?.type === 2 ? 'plus' : 'normal');
  },

  watch: {
    gPaginationHospital: {
      handler(value) {
        this.pagination = Object.assign(value, {});
        this.paginationPages = value.last_page;
      },
      deep: true,
    },
  },

  computed: {
    ...hospitalComputed,
    ...configComputed,

    theme() {
      return this.$store.state.theme;
    },

    fields() {
      return [
        {
          key: "#",
          class: "text-center align-middle p-3 tilte-column"
        },
        {
          key: "mobile",
          label: "携帯番号",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "patient_id",
          label: '会員ID',
          class: "text-start align-middle p-3 tilte-column",
        },
        {
          key: "age",
          formatter: val => (val && val) ? val + " 歳" : "",
          label: "年齢",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "sex",
          formatter: val => ["女性", "男性", "無回答"][val] ?? "無回答",
          label: "性別",
          class: "text-start align-middle p-3 tilte-column",
          sortable: true,
        },
        {
          key: "height",
          label: "身長",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "weight",
          label: "体重",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "bmi",
          label: "BMI",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "locomo7",
          label: "",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "locomo25",
          label: "",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "hipscore",
          label: "",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "harriscore",
          label: "",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "fjs12",
          label: "",
          class: "text-end align-middle p-3 tilte-column",
        },
        {
          key: "created_at",
          label: this.$t("menuitems.user.facilities"),
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "updated_at",
          label: this.$t("menuitems.user.facilities"),
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "action",
          label: "操作",
          class: "text-center align-middle p-3 tilte-column",
        },
      ];
    },
  },

  methods: {
    ...hospitalMethods,
    ...configMethods,

    isLastFacilityTimeout(joinFacility) {
      if (joinFacility === null) return false;
      const facilities = JSON.parse(joinFacility);
      if (joinFacility.length === 0) return false;
      const lastFacility = facilities[facilities.length - 1];

      return lastFacility.time_out;
    },

    reloadPage() {
      window.location.reload();
    },

    changeSelected() {
      document.onkeyup = (e) => {
        if (e.keyCode === 13) {
          this.onFilter();
        }
      };
    },

    isChecked(id) {
      return (
        (this.isAll && !this.ignoreIds.includes(id)) ||
        this.excelIds.includes(id)
      );
    },

    isCheckedAll() {
      if (this.gHospitals.length > 0) {
        return (
          (this.isAll && this.ignoreIds.length === 0) ||
          this.excelIds.length === this.gPaginationHospital.total
        );
      }

      return false;
    },

    checkAll() {
      if (this.ignoreIds.length > 0) {
        this.ignoreIds = [];
      } else {
        this.isAll = !this.isAll;
        if (!this.isAll) {
          this.excelIds = [];
        }
      }
    },

    async handlerSearch(page = 1) {
      try {
        if (this.filter.age > 120) {
          window.toastr.error("1から120までの整数を入力する必要があります。もう一度やり直してください");
          return;
        }
        this.loader = true;
        this.page = page < 1 ? 1 : page;
        const payloadSearch = Object.assign(
          {
            role: "user",
            page: this.page,
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
          },
          this.filter
        );
        payloadSearch.birthday = payloadSearch.birthday
          ? filter.fomatDate(payloadSearch.birthday, "YYYY/MM/DD")
          : null;
        await this.fetchHospital(payloadSearch).then((e) => {
          if (e.status === 200) {
            this.loader = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    async onFilter() {
      this.getHCountUser();
      this.initExport();
      await this.handlerSearch();
    },

    async onClear() {
      this.filter = {};
      this.valueSelectSex = "";
      this.initExport();
      await this.handlerSearch();
    },

    onSort(key) {
      if (key === this.keySort) {
        this.typeSort = Math.abs(this.typeSort - 1);
      } else {
        this.keySort = key;
        this.typeSort = 0;
      }

      this.handlerSearch();
    },

    activeExport() {
      if (this.gHospitals.length > 0) {
        return !this.isAll && this.excelIds.length === 0;
      }

      return false;
    },

    activeDelete() {
      if (this.gHospitals.length > 0) {
        if (this.isAll) {
          if (this.ignoreIds.length > 0) {
            for (let i=0; i<this.gHospitals.length; i++) {
              if (!this.ignoreIds.includes(this.gHospitals[i].id) && !this.isLastFacilityTimeout(this.gHospitals[i].join_facility)) {
                return false;
              }
            }
          } else {
            for (let i=0; i<this.gHospitals.length; i++) {
              if (!this.isLastFacilityTimeout(this.gHospitals[i].join_facility)) {
                return false;
              }
            }
          }
        } else {
          for (let i=0; i<this.gHospitals.length; i++) {
              if (this.excelIds.length > 0 && this.excelIds.includes(this.gHospitals[i].id) && !this.isLastFacilityTimeout(this.gHospitals[i].join_facility)) {
                return false;
              }
            }
        }
      }

      return true;
    },

    exportExcel() {
      if (!this.isAll && this.excelIds.length === 0) {
        window.toastr.error("会員を選択してください");
      } else {
        try {
          let payload = {
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
          };
          if (this.isAll) {
            if (this.filter.age !== undefined && this.filter.age !== "") {
              payload.age = this.filter.age;
            }
            if (this.filter.fullname !== undefined && this.filter.fullname !== "") {
              payload.fullname = this.filter.fullname;
            }
            if (this.filter.mobile !== undefined && this.filter.mobile !== "") {
              payload.mobile = this.filter.mobile;
            }
            if (this.filter.sex !== undefined && this.filter.sex) {
              payload.sex = this.filter.sex.value;
            }
            if (this.ignoreIds.length > 0) {
              payload.ignore_ids = this.ignoreIds.toString();
            }
          } else {
            payload.ids = this.excelIds.toString();
          }
          payload.role = this.role;
          api.exportExcelUser(payload);
          this.initExport();
        } catch (error) {
          console.log(error);
        }
      }
    },

    chooseItem(id) {
      if (this.isAll) {
        this.ignoreIds = this.setArray(this.ignoreIds, id);
        if (this.ignoreIds.length === this.gPaginationHospital.total) {
          this.isAll = false;
          this.ignoreIds = [];
        }
      } else {
        this.excelIds = this.setArray(this.excelIds, id);
        if (this.excelIds.length === this.gPaginationHospital.total) {
          this.isAll = true;
          this.ignoreIds = [];
        }
      }
    },

    setArray(array, id) {
      const index = array ? array.findIndex((element) => element === id) : -1;
      index >= 0 ? array.splice(index, 1) : array.push(id);

      return array;
    },

    initExport() {
      this.isAll = false;
      this.ignoreIds = [];
      this.excelIds = [];
    },

    checkDisabled() {
      const check =
        this.filter.mobile ||
        this.filter.fullname ||
        this.filter.age ||
        this.filter.birthday ||
        this.valueSelectSex;
      return !check;
    },

    selectFilterSex(context) {
      if (!context) return;
      this.filter.sex = context.value;
    },

    async OnPagination(page) {
      try {
        this.loader = true;
        await this.handlerSearch(page);
      } catch (error) {
        console.log(error);
      }
    },

    showAddUserModal() {
      this.openedAddModal = true;
    },

    closeAddModal() {
      this.openedAddModal = false;
    },

    showTestModal(user) {
      this.openedTestModal = true;
      this.testingUser = user;
    },

    removeUser() {
      try {
        this.confirm(
          {
            title: "",
            text: "この会員を削除しますか",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: this.theme === 'normal' ? "#8FC31F" : "#395299",
            cancelButtonColor: "#FF5858",
            confirmButtonText: "はい",
            cancelButtonText: "いいえ",
          },
          async (e) => {
            if (e.isConfirmed) {
              const res = await this.doAction("remove");
              console.log(res);
              // if (res.status == 200) {
                window.toastr.success("削除に成功しました");
                await this.onFilter();
              // } else {
              //   window.toastr.error("削除に失敗しました");
              // }
            }
          }
        )
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    async doAction(type) {
      if (!this.isAll && this.excelIds.length === 0) {
        window.toastr.error("会員を選択してください");
      } else {
        try {
          let payload = {
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
          };
          if (this.isAll) {
            let chooseIds = [];
            for (let i = 0; i < this.gHospitals.length; i++) {
              chooseIds.push(this.gHospitals[i].id);
            }
            if (this.ignoreIds.length > 0) {
              payload.ignore_ids = this.ignoreIds.toString();
              payload.ids = chooseIds.filter(item => !this.ignoreIds.includes(item));
            } else {
              payload.ids = chooseIds;
            }
          } else {
            payload.ids = this.excelIds;
          }
          payload.role = this.role;
          console.log(payload);

          for (let i = 0; i < payload.ids.length; i++) {
            await api.removeUserFromFacility(payload.ids[i], this.profile.facility?.id)
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    confirmRemove(user) {
      try {
        this.confirm(
            {
              title: "",
              text: "この会員を削除しますか",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: this.theme === 'normal' ? "#8FC31F" : "#395299",
              cancelButtonColor: "#FF5858",
              confirmButtonText: "はい",
              cancelButtonText: "いいえ",
            },
            async (e) => {
              if (e.isConfirmed) {
                await api.removeUserFromFacility(user.id, this.profile.facility?.id);
                await this.onFilter();
                window.toastr.success("削除に完了しました");
              }
            }
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },

    closeTestModal() {
      this.openedTestModal = false;
    },

    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
    },

    async handlerEditProfileUser(id) {
      try {
        this.showModalEditProfileUser = true;
        this.dataEdit = this.gHospitals.find(item => item.id === id)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }

    },

    async closeModal() {
      this.showModalEditProfileUser = false;
    },
  },
};
</script>

<template>
  <div :id="theme">
  <Layout class="kurua-page">
    <div class="position-relative d-flex mb-5 mb-md-3 mt-lg-n1 mb-lg-2">
      <div class="col-12 mt-md-1 mt-lg-3">
        <PageHeader :items="items" fontSize="28px" fontWeight="700 !important"/>
      </div>
      <div class="position-absolute mt-n3 mt-md-n1 mt-lg-n3 d-flex" style="margin-left: 120px">
        <button @click="reloadPage" class="custom-button">
          <img src="@/assets/images/icon/icon-reload.svg" alt="" style="width: 20px; height: 20px;" />
           更新
        </button>
        <div class="ml-1">
          <p style="margin: 0; padding-left: 10px; font-size: 14px;">最終更新日時:</p>
          <p style="margin: 0; padding-left: 10px; font-size: 14px; margin-top: -5px;">{{ lastLoadedTime }}</p>
        </div>
      </div>
      <div class="position-absolute mt-4 mt-md-n1 mt-lg-n3 mt-xl-n3 col-xl-4 col-lg-5 col-md-7 text-white" style="right: 0rem;">
        <div class="row d-flex justify-content-end">
          <div class="col-3">
            <b-button class="btn btn-outline-lyg w-100 btn-secondary px-0"
              style="margin-left: 30px;"
              @click="toggleFilter()">
              <img :src="theme === 'normal' ? require('@/assets/images/icon/icon-filter-nor.svg') : require('@/assets/images/icon/icon-filter.svg')" alt="" style="width: 20px; height: 20px;" />
              絞り込み
            </b-button>
          </div>
          <div class="col-3">
            <b-button :disabled="activeExport()" :class="{'bg-disabled': activeExport()}" class="btn-lyg w-100 px-0" style="margin-left: 20px;" @click="exportExcel()">
              <img
                :src="!activeExport() ? require('@/assets/images/icon/icon-export-white.svg') : require('@/assets/images/icon/icon-export.svg')"
                alt="" style="width: 20px; height: 20px;" />
                Excel出力
            </b-button>
          </div>
          <div class="col-3">
            <b-button :disabled="activeDelete()" :class="{ 'bg-disabled': activeDelete() }"
              class="btn-danger w-100 px-1 h-100" @click="removeUser()" style="margin-left: 10px;">
              <img
                :src="!activeDelete() ? require('@/assets/images/icon/icon-trash-white.svg') : require('@/assets/images/icon/icon-trash.svg')"
                alt="" style="width: 20px; height: 20px;" />
              削除</b-button>
          </div>
          <div class="col-3">
            <b-button class="btn btn-lyg w-100 h-100 text-button btn-secondary px-1" @click="showAddUserModal()">患者登録</b-button>
          </div>
        </div>
      </div>
    </div>
    <Add :isShow="openedAddModal" @close="closeAddModal" @added="onFilter" />
    <RokomoTest v-if="openedTestModal" :user="testingUser" @close="closeTestModal" />
    <EditProfileUser lazy @closeModal="closeModal" :isShowEdit="showModalEditProfileUser" :data="dataEdit"/>
    <div class="card" v-if="isFilterOpen">
      <div class="col-12 px-4 py-3">
        <h5>{{ $t("menuitems.hospital.filter") }}</h5>
        <hr class="mb-2" />
        <form action="" @submit.prevent="onFilter">
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.mobile')" label-for="userId">
                <b-form-input type="search" v-model="filter.mobile" :placeholder="$t('menuitems.hospital.placeholderMobile')"
                  for="userId" value="" class="helo" :maxlength="256"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-md-4">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.userId')" label-for="会員ID">
                <b-form-input v-model="filter.patient_id" :placeholder="$t('menuitems.hospital.placeholderUserId')"
                  for="会員ID" :maxlength="256" value="" class="helo" type="filter"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.age')" label-for="age">
                <b-form-input type="number" :min="1" :max="120" v-model.number="filter.age"
                  :formatter="(e) => e ? (e > 120 ? 120 : (e < 1 ? 1 : e)) : undefined"
                  :placeholder="$t('menuitems.hospital.placehoderAge')" for="age" value="" class="helo">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <b-form-group class="mb-3 text-table" :label="$t('menuitems.hospital.sex')" label-for="sex">
                <multiselect for="sex" :show-labels="false" v-model="valueSelectSex" label="label"
                  @input="changeSelected" :searchable="false" @select="selectFilterSex" track-by="value"
                  :options="gGetConfig.gender || []" class="helo" :placeholder="'性別を選択してください。'"></multiselect>
              </b-form-group>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 text-white">
              <div class="row">
                <div class="col-6">
                  <b-form-group label="0000">
                    <b-button type="submit" class="btn btn-lyg w-100 text-button btn-secondary">
                      {{ $t("menuitems.hospital.search") }}
                    </b-button>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group label="0000">
                    <button class="
                        btn btn-outline-lyg
                        text-button
                        btn-clear-filter
                        w-100
                      " @click="onClear()"> クリア </button>
                  </b-form-group>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="mb-0" :style="{minHeight: isFilterOpen ? '50vh' : '80vh'}">
      <Loader :loading="loader">
        <div class="col-12">
          <b-table :items="gHospitals || []" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
            sort-icon-left hover outlined thead-class="sticky-top text-center bg-table-lyg" sticky-header :style="{ maxHeight: isFilterOpen ? '50vh' : '75vh' }" responsive="sm">
            <template #head()="{ label, field: { key, sortable } }">
              {{ label }}
              <template v-if="sortable">
                <!-- Custom icons -->
                <template>
                  <span v-if="sortBy !== key">
                    <i class="mdi mdi-sort-bool-ascending"></i>
                  </span>
                  <span v-else-if="sortDesc">
                    <i class="mdi mdi-sort-bool-descending"></i>
                  </span>
                  <span v-else>
                    <i class="mdi mdi-sort"></i>
                  </span>
                </template>
              </template>
            </template>
            <template #head(#)>
              <b-form-checkbox id="checkbox-all" @change="checkAll()" name="checkbox-all" :checked="isCheckedAll()"></b-form-checkbox>
            </template>

            <!-- cell patient_id -->
            <template #cell(patient_id)="row">
              {{ row.item.patient_id }}
            </template>

            <template #head(age)="row">
              <div @click="onSort('information.age')" :style="{ minWidth: '50px' }">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'information.age'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 0"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 1"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'information.age'"></i>
                </span>
              </div>
            </template>
            <template #head(birthday)="row">
              <div @click="onSort('information.birthday')" :style="{ minWidth: '50px' }">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'information.birthday'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'information.birthday'"></i>
                </span>
              </div>
            </template>
            <template #head(mobile)="row">
              <div @click="onSort('mobile')">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'mobile'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'mobile'"></i>
                </span>
              </div>
            </template>
            <template #head(patient_id)="row">
              <div @click="onSort('patient_id')">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'patient_id'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'patient_id'"></i>
                </span>
              </div>
            </template>
            <template #head(height)="row">
              <div @click="onSort('height')" :style="{ minWidth: '50px' }">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'height'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'height'"></i>
                </span>
              </div>
            </template>
            <template #head(weight)="row">
              <div @click="onSort('weight')" :style="{ minWidth: '50px' }">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'weight'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'weight'"></i>
                </span>
              </div>
            </template>
            <template #head(bmi)="row">
              <div @click="onSort('bmi')" :style="{ minWidth: '50px' }">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'bmi'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'bmi'"></i>
                </span>
              </div>
            </template>
            <template #head(locomo7)="row">
              <div :style="{ minWidth: '80px' }">7つのロコチェック</div>
              <div @click="onSort('locomo7')">
                (点数)
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'locomo7'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'locomo7'"></i>
                </span>
              </div>
            </template>
            <template #head(locomo25)="row">
              <div :style="{ minWidth: '80px' }">ロコモ25</div>
              <div @click="onSort('locomo25')">
                (ロコモ度)
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'locomo25'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'locomo25'"></i>
                </span>
              </div>
            </template>
            <template #head(hipscore)="row">
              <div :style="{ minWidth: '80px' }">股関節スコア１</div>
              <div @click="onSort('hipscore')">
                (点数)
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'hipscore'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'hipscore'"></i>
                </span>
              </div>
            </template>
            <template #head(harriscore)="row">
              <div :style="{ minWidth: '80px' }">股関節スコア２</div>
              <div @click="onSort('harriscore')">
                (点数)
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'harriscore'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'harriscore'"></i>
                </span>
              </div>
            </template>
            <template #head(fjs12)="row">
              <div :style="{ minWidth: '90px' }">股関節の違和感チェック</div>
              <div @click="onSort('fjs12_score')">
                (点数)
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'fjs12_score'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'fjs12_score'"></i>
                </span>
              </div>
            </template>
            <template slot="selected" slot-scope="data">
              <b-form-checkbox @click.native.stop :value="data.item.schoolId" :checked="allSelected"></b-form-checkbox>
              {{ data.index }}
            </template>
            <template #cell(#)="row">
              <b-form-checkbox id="checkbox-1" @change="chooseItem(row.item.id)" name="checkbox-1" :checked="isChecked(row.item.id)"></b-form-checkbox>
            </template>
            <template #cell(mobile)="row">
              <a @click="$router.push(`/hospital/users/${row.item.uuid}`)" class="text-link" style="cursor: pointer;">{{ row.item.mobile }} </a>
            </template>
            <template #cell(age)="row">
              {{ row.item.information?.age ?? '-' }}
            </template>
            <template #cell(birthday)="row">
              {{ row.item.information?.birthday }}
            </template>
            <template #cell(locomo7)="row">
              <span>{{ row.item.exam | filterSurveyType1 }} </span>
            </template>
            <template #cell(locomo25)="row">
              <span>{{ row.item.exam | filterSurveyType2 }} </span>
            </template>
            <template #cell(hipscore)="row">
              <span>{{ row.item.exam | filterSurveyType3 }} </span>
            </template>
            <template #cell(harriscore)="row">
              <span>{{ row.item.exam | filterSurveyType4 }} </span>
            </template>
            <template #cell(fjs12)="row">
              <span>{{ row.item.fjs12_score ?? '-' }}</span>
            </template>

            <template #head(sex)="row">
              <div @click="onSort('information.sex')" :style="{ minWidth: '50px' }">
                <span>{{ row.label }}</span>
                <span v-if="keySort === 'information.sex'">
                  <span>
                    <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  </span>
                  <span>
                    <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                  </span>
                </span>
                <span>
                  <i class="mdi mdi-sort" v-if="keySort !== 'information.sex'"></i>
                </span>
              </div>
            </template>
            <template #cell(sex)="row">
              {{ ["女性", "男性", "無回答"][row.item.information?.sex] ?? "無回答" }}
            </template>

            <template #cell(height)="row">
              <span>{{ row.item.height ?? '-'}} </span>
            </template>
            <template #cell(weight)="row">
              <span>{{ row.item.weight ?? '-'}} </span>
            </template>
            <template #cell(bmi)="row">
              <span>{{ row.item.bmi ? parseFloat(row.item.bmi).toFixed(2) : '-' }}</span>
            </template>

            <!-- cell created_at -->
            <template #head(created_at)="row">
              <div @click="onSort('created_at')">
                <span>登録日</span>
                <span v-if="keySort === 'created_at'">
                  <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                </span>
                <i class="mdi mdi-sort" v-if="keySort !== 'created_at'"></i>
              </div>
            </template>
            <template #cell(created_at)="row">
              {{ row.item.created_at | fomatDate2 }}
            </template>

            <!-- cell updated_at -->
            <template #head(updated_at)="row">
              <div @click="onSort('updated_at')">
                <span>最終更新日</span>
                <span v-if="keySort === 'updated_at'">
                  <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 1"></i>
                  <i class="mdi mdi-sort-bool-descending" v-if="typeSort == 0"></i>
                </span>
                <i class="mdi mdi-sort" v-if="keySort !== 'updated_at'"></i>
              </div>
            </template>
            <template #cell(updated_at)="row">
              <span v-if="!isLastFacilityTimeout(row.item.join_facility)">
                {{ row.item.updated_at | fomatDate2 }}
              </span>
              <span v-else>
                {{isLastFacilityTimeout(row.item.join_facility) | formatDateLocal}}
              </span>
            </template>

            <template #cell(action)="row">
              <ul class="list-inline font-size-20 contact-links mb-0 custom-list" v-if="!isLastFacilityTimeout(row.item.join_facility)">
                <li title="測定" class="list-inline-item px-1">
                  <a @click="showTestModal(row.item)">
                    <i class="bx bx-user-check text-white bg-icon p-1" style="border-radius: 50%; cursor: pointer"></i>
                  </a>
                </li>
                <li v-if="profile.is_plus" title="リハビリAI" class="list-inline-item px-1">
                  <a @click="$router.push(`/hospital/users/${row.item.uuid}/rehab-video-suggestions`)"  >
                    <img :src="require('@/assets/images/icon/ai01.png')" alt="" style="width: 33px; height: 30px; margin-top: -.5rem; cursor: pointer;" />
                  </a>
                </li>
                <li title="編集" @click=handlerEditProfileUser(row.item.id) :showEdit="true" class="list-inline-item px-1 icon-large">
                  <a>
                    <img :src="theme === 'normal' ? require('@/assets/images/icon/icon-changes-nor.svg') : require('@/assets/images/icon/icon-changes.svg')" alt="" style="width: 28px; height: 28px; margin-top: -.5rem; cursor: pointer;" />
                  </a>
                </li>
              </ul>
              <span v-else>
                削除済み
              </span>

            </template>
          </b-table>
        </div>
        <div class="d-flex justify-content-center text-center mt-5" v-if="this.gHospitals.length === 0">
          <div class="undefine">
            <img src="@/assets/images/no-data.jpg" alt="" />
            <div class="mt-3">詳細データはありません。</div>
          </div>
        </div>
        <Pagination :paging="pagination" @change="OnPagination" :theme="theme" label="患者数：" unitLabel="名"/>
      </Loader>
    </div>
  </Layout>
  </div>
</template>

<style lang="scss" scoped>
::v-deep th {
  text-align: center !important;
}
</style>
